module.exports = __webpack_public_path__ + "static/img/giphy.59d9d39.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/giphy.gif
// module id = kNSQ
// module chunks = 1